import axios from "axios";

// TODO: fix
// const baseURL = "https://eventpro.lo.cal";
const baseURL = process.env.VUE_APP_API_URL;
const api = axios.create({baseURL});
api.defaults.withCredentials = true;
// Add a 401 response interceptor
api.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {
        window.location = '/';
    }
    return Promise.reject(error);
});
const paramEncoder = (obj = {}) => {
    return '?' + Object.keys(obj).map(k => k + '=' + encodeURIComponent(obj[k])).join('&');
};

export {
    api,
    paramEncoder
}